import { Tab, Tabs } from "react-bootstrap";
import { FaCodeBranch, FaUser } from "react-icons/fa";
import { IoLocationSharp } from "react-icons/io5";
import { MdLock } from "react-icons/md";
import Address from './Address';
import Profile from './Profile';
import UpdatePassword from "./UpdatePassword";
import FranchiseSetting from "./FranchiseSetting";

const Settings = () => {
    return (
        <>
            <Tabs
                defaultActiveKey="profile"
                id="fill-tab-example"
                className=""
                fill
            >
                <Tab
                    eventKey="profile"
                    title={
                        <span className="d-flex align-items-center justify-content-center gap-2">
                            <FaUser size={14} />
                            Profile
                        </span>
                    }
                >
                    <Profile />
                </Tab>

                <Tab
                    eventKey="franchise"
                    title={
                        <span className="d-flex align-items-center justify-content-center gap-2">
                            <FaCodeBranch size={14} />
                            Franchise Settings
                        </span>
                    }
                >
                    <FranchiseSetting />
                </Tab>

                <Tab
                    eventKey="address"
                    title={
                        <span className="d-flex align-items-center justify-content-center gap-2">
                            <IoLocationSharp size={16} />
                            Shipping Address
                        </span>
                    }
                >
                    <Address />
                </Tab>

                <Tab
                    eventKey="change-password"
                    title={
                        <span className="d-flex align-items-center justify-content-center gap-2">
                            <MdLock size={16} />
                            Change Password
                        </span>
                    }
                >
                    <UpdatePassword />
                </Tab>
            </Tabs>
        </>
    )
}

export default Settings